<div class="sub-collection" [ngStyle]="getBorderColor()">
    <div class="border-wrapper">
        <a
            class="title gtm-collection-subcollection-title selenium-collection-subcollection-title"
            [attr.data-gtmlabel]="collection.title"
            [routerLink]="getNodeRouterLink(collection)"
            [queryParams]="{ student: isStudent ? true : null }"
            [innerHTML]="collection.title"
        >
        </a>
        <div class="description" [innerHTML]="collection.description"></div>
        <app-resources-section
            *ngIf="collection.children.length === 0"
            [resources]="collection.resources"
            [start]="0"
            [stop]="3"
            (loaded)="updateLoadingState($event)"
        >
        </app-resources-section>
        <div class="boxes">
            <app-collection-box
                *ngFor="let collection of collection.children | slice: 0 : subCollectionsCount"
                [collection]="collection"
            ></app-collection-box>
        </div>
        <app-link
            class="go-to-link gtm-collection-subcollection-goto selenium-collection-subcollection-goto"
            [attr.data-gtmlabel]="collection.title"
            *ngIf="collection.children.length === 0"
            [appRouterLink]="getNodeRouterLink(collection)"
            [queryParams]="{ student: isStudent ? true : null }"
        >
            Go to {{ collection.title }}
            <span *ngIf="collection.totalResources">({{ collection.totalResources }})</span>
        </app-link>
        <app-button
            (click)="triggerMoreButton()"
            *ngIf="totalSubCollectionsCount && totalSubCollectionsCount > minSubCollectionCount"
        >
            <span *ngIf="totalSubCollectionsCount > subCollectionsCount">More +</span>
            <span *ngIf="totalSubCollectionsCount <= subCollectionsCount">Less -</span>
        </app-button>
    </div>
</div>
<div
    class="w-100 fw-bold text-center my-7"
    *ngIf="!collection.totalResources && !isLoading && isStudent"
>
    <!--    remove this 'if' logic if the empty collection will be filtered from BE-->
    No resources available
    <span *ngIf="selectedFilter !== 'All grades'"
        >for Grades {{ selectedFilter }}. Filter by All Grades to see the full collection.
    </span>
</div>
